"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgentEditIsActiveEditor = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const __1 = require("..");
const CheckBox_1 = require("../../../CheckBox");
const AgentEditIsActiveEditor = (props) => {
    const { fields } = props;
    if (fields.isActive.hidden)
        return null;
    return (react_1.default.createElement("div", { className: `${__1.className}__field ${__1.className}__field--with-checkbox` },
        react_1.default.createElement(CheckBox_1.CheckBox, { text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/User/Edit:Active', defaultMessage: 'Active' }), name: 'isActive', error: fields.isActive.error, checked: fields.isActive.value, onChange: fields.isActive.onEvent, modificators: fields.isActive.modifiers, disabled: fields.isActive.disabled })));
};
exports.AgentEditIsActiveEditor = AgentEditIsActiveEditor;
//# sourceMappingURL=isActive.js.map